import { render, staticRenderFns } from "./ticketChat.vue?vue&type=template&id=fcae3e3c&"
import script from "./ticketChat.vue?vue&type=script&lang=js&"
export * from "./ticketChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports